import { CLEAR_STORE, LOAD_REFERRAL_HISTORY } from '../../action-contants';

const INITIAL_STATE = {
  total_instapoints: 0,
  referrals: []
};

export default function referralReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CLEAR_STORE: {
      return INITIAL_STATE;
    }
    case LOAD_REFERRAL_HISTORY: {
      return { ...state, ...action.data };
    }
    default:
      return state;
  }
}
